import { render, staticRenderFns } from "./TherapistDashIntro.vue?vue&type=template&id=b604f1a2&scoped=true"
import script from "./TherapistDashIntro.vue?vue&type=script&lang=js"
export * from "./TherapistDashIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b604f1a2",
  null
  
)

export default component.exports